<template>
  <router-link v-if="displayLink" :to="link" class="btn-primary action-link">
    {{hgCurrentStep.actionText}}
  </router-link>
</template>

<script>
export default {
  props: {
    hgCurrentStep: {
      required: true,
      type: Object,
    },
    hgFolderId: {
      required: false,
      type: String,
    },
    hgCompanyId: {
      required: true,
      type: Number,
    },
  },
  computed: {
    displayLink() {
      return this.hgCurrentStep
        && this.hgCurrentStep.actionType !== 'none';
    },
    link() {
      if (!this.hgCurrentStep) return '';

      switch (this.hgCurrentStep.actionTargetType) {
        case 'agreement':
          return this.hgCurrentStep.actionTargetId
            ? `/company/${this.hgCompanyId}/agreements/${this.hgCurrentStep.actionTargetId}`
            : '';
        case 'payment':
          return this.hgFolderId
            ? `/company/${this.hgCompanyId}/folder/${this.hgFolderId}/payment`
            : '';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.action-link {
  margin-left: 20px;
  white-space: nowrap;
}
</style>
